import styled from "@emotion/styled/macro";
import {
  Card,
  CardHeader,
  Banner,
  BannerTypes,
} from "@sunrun/experience-ui-components";
import { Contact } from "@sunrun/experience-ui-components/lib/components/ContactCard";
import { TitleInfoContacts } from "./TitleInfoContacts";

type TitleInfoContentProps = {
  selectedPrimaryContact?: Contact;
  setSelectedPrimaryContact: (contact: Contact) => void;
  selectedSecondaryContact?: Contact;
  setSelectedSecondaryContact: (contact: Contact | undefined) => void;
  selectedUtilityContact?: Contact;
  setSelectedUtilityContact: (contact: Contact) => void;
  refSetter?: (node: HTMLDivElement | null) => void;
  hasOffers?: boolean;
  hasSignedOffer?: boolean;
  offerApproved?: boolean;
  refetchContacts: () => void;
  namesOnTitle?: string[];
};

const TitleInfoContent: React.FC<TitleInfoContentProps> = ({
  selectedPrimaryContact,
  setSelectedPrimaryContact,
  selectedSecondaryContact,
  setSelectedSecondaryContact,
  selectedUtilityContact,
  setSelectedUtilityContact,
  refSetter,
  hasOffers,
  hasSignedOffer,
  offerApproved,
  refetchContacts,
  namesOnTitle = [],
}) => {
  return (
    <StyledTitleInfoContent>
      <Banner
        bannerType={BannerTypes.WarningLight}
        show={true}
        showClose={false}
      >
        Your deal will get rejected if customer who signs is not on title
      </Banner>
      <Card>
        <CardHeader>Names on Title</CardHeader>
        <div>{namesOnTitle.join(",")}</div>
      </Card>
      <TitleInfoContacts
        selectedPrimaryContact={selectedPrimaryContact}
        setSelectedPrimaryContact={setSelectedPrimaryContact}
        selectedSecondaryContact={selectedSecondaryContact}
        setSelectedSecondaryContact={setSelectedSecondaryContact}
        selectedUtilityContact={selectedUtilityContact}
        setSelectedUtilityContact={setSelectedUtilityContact}
        refSetter={refSetter}
        hasOffers={hasOffers}
        hasSignedOffer={hasSignedOffer}
        offerApproved={offerApproved}
        refetchContacts={refetchContacts}
      />
    </StyledTitleInfoContent>
  );
};

const StyledTitleInfoContent = styled.div`
  display: grid;
  grid-row-gap: 32px;
  margin-bottom: 32px;

  @media (max-width: 1100px) {
    width: 100%;
  }
`;

export { TitleInfoContent };
export type { TitleInfoContentProps };
